import * as React from "react"
const SvgParagraph = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 20.143a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712v-5q-2.075 0-3.537-1.463Q4.999 11.218 5 9.143c.001-2.075.487-2.563 1.463-3.538Q7.925 4.143 10 4.143h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288h-1v13q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712v-13h-3v13a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288" />
  </svg>
)
export default SvgParagraph
